export default __webpack_public_path__ + "static/media/partly-cloudy-day.8d1e08ba.svg";